"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsenceRequestMessage = void 0;
const model_1 = require("../model");
const utils_1 = require("../utils");
const base_html_1 = require("./base-html");
class AbsenceRequestMessage {
    get replyTo() {
        return this.employee.email;
    }
    get _startString() {
        return (0, utils_1.formatDate)(this.absence.start);
    }
    get _endString() {
        return (0, utils_1.formatDate)((0, utils_1.dateAdd)(this.absence.end, { days: -1 }));
    }
    constructor(vals) {
        Object.assign(this, vals);
    }
    get recipient() {
        return this.manager.email;
    }
    get title() {
        if (this.updated) {
            return `${this.absence.type === model_1.TimeEntryType.Vacation ? `Urlaubsantrag` : `Krankmeldung`} von ${this.employee.name} wurde geändert: ${this._startString} bis ${this._endString}`;
        }
        else {
            return `${this.absence.type === model_1.TimeEntryType.Vacation ? `Neuer Urlaubsantrag` : `Neue Krankmeldung`} von ${this.employee.name}: ${this._startString} bis ${this._endString}`;
        }
    }
    get text() {
        var _a;
        return `
Hallo ${this.manager.firstName},

${this.updated
            ? `${this.employee.name} hat ${this.absence.type === model_1.TimeEntryType.Vacation ? "einen Urlaubsantrag" : "eine Krankmeldung"} bearbeitet. Neuer Zeitraum: ${this._startString} bis ${this._endString}.`
            : `Es liegt ${this.absence.type === model_1.TimeEntryType.Vacation ? "ein neuer Urlaubsantrag" : "eine neue Krankmeldung"} von ${this.employee.name} über den Zeitraum vom ${this._startString} bis ${this._endString} vor.`}

${((_a = this.absence.request) === null || _a === void 0 ? void 0 : _a.message) ? `Nachricht: "${this.absence.request.message}"` : ""}

Über den folgenden Link kannst du diesen genehmigen oder ablehnen:

${this.url}

Liebe Grüße,
Dein Pentacode Team
`;
    }
    get html() {
        var _a;
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.manager.firstName},`)}

            ${this.updated
            ? (0, base_html_1.paragraph)(`${this.employee.name} hat ${this.absence.type === model_1.TimeEntryType.Vacation ? "einen Urlaubsantrag" : "eine Krankmeldung"} bearbeitet. Neuer Zeitraum: <strong>${this._startString}</strong> bis <strong>${this._endString}</strong>.`)
            : (0, base_html_1.paragraph)(`Es liegt ${this.absence.type === model_1.TimeEntryType.Vacation
                ? "ein neuer Urlaubsantrag"
                : "eine neue Krankmeldung"} von ${this.employee.name} über den Zeitraum vom <strong>${this._startString}</strong> bis <strong>${this._endString}</strong> vor.`)}

            ${((_a = this.absence.request) === null || _a === void 0 ? void 0 : _a.message) ? (0, base_html_1.paragraph)(`Nachricht: "${this.absence.request.message}"`) : ""}

            ${(0, base_html_1.paragraph)(`Über den folgenden Button kannst du diesen genehmigen oder ablehnen:`)}

            ${(0, base_html_1.button)("Antrag Beantworten", this.url)}

            ${(0, base_html_1.paragraph)(`
                Liebe Grüße,<br>
                Dein Pentacode Team
            `)}
        `);
    }
}
exports.AbsenceRequestMessage = AbsenceRequestMessage;
//# sourceMappingURL=absence-request.js.map